import dynamic from "next/dynamic";

export function NoSSR(importer: () => Promise<any>) {
    return dynamic(importer, { ssr: false });
}


export const isSSR = () => typeof window === "undefined";